import axios from 'axios'

import cookie from './helpers/cookie'
import getRequestParams from './helpers/getRequestParams'
import getFullUrl from './helpers/getFullUrl'
import {analytics} from '@/app/js/analytics'

const COOKIE_PARAMS = ['visit', 'start_page', 'utm_medium', 'utm_source', 'utm_content', 'utm_keyword', 'user']

const referrer = document.referrer ? (getFullUrl(document.referrer)) : ''

const options = {
  'expires': new Date(new Date().getTime() + 30 * 3600 * 1000),
  'path:': '/'
}

if (!referrer || referrer.host !== location.host) {
  const requestParams = getRequestParams()
  if (cookie.getCookie('uls_visit') === undefined) {
    cookie.setCookie('uls_visit', 0, options)
  } else {
    cookie.setCookie('uls_visit', parseInt(cookie.getCookie('uls_visit')) + 1, options)
  }
  cookie.setCookie('uls_start_page', location.toString(), options)
  if (requestParams.hasOwnProperty('utm_medium')) {
    cookie.setCookie('uls_utm_medium', requestParams['utm_medium'], options)
  }
  if (requestParams.hasOwnProperty('utm_source')) {
    cookie.setCookie('uls_utm_source', requestParams['utm_source'], options)
  }
  if (requestParams.hasOwnProperty('utm_content')) {
    cookie.setCookie('uls_utm_content', requestParams['utm_content'], options)
  }
  if (requestParams.hasOwnProperty('utm_keyword')) {
    cookie.setCookie('uls_utm_keyword', requestParams['utm_keyword'], options)
  }
  if (requestParams.hasOwnProperty('utm_campaign')) {
    cookie.setCookie('uls_utm_campaign', requestParams['utm_campaign'], options)
  }
}

if (cookie.getCookie('uls_user') === undefined) {
  cookie.setCookie(
    'uls_user',
    (function () {
      return (Math.floor(Math.random() * Math.pow(10, 6))).toString() + (Date.now() % Math.pow(10, 5)).toString()
    })(),
    options
  )
}

const getFormData = function (form) {
  if (form.length > 0) {
    let source = ''
    if (form.dataset.source) {
      source = form.dataset.source
    }
    const data = new FormData(form)
    data.append('source', source)
    data.append('current_page', location.toString())
    COOKIE_PARAMS.forEach((i, param) => {
      const value = cookie.getCookie('uls_' + param)
      if (value) {
        data.append(param, value)
      }
    })

    return data
  }
  return null
}


export function formHandler({form, onSuccess, onValidationError, onFatalError}) {
  form.addEventListener('submit', function (e) {
    e.preventDefault()

    const grecaptcha = window.grecaptcha

    grecaptcha.ready(() => {
      grecaptcha.execute(document.documentElement.dataset.recaptchaPublicToken, {action: 'submit'})
        .then((token) => {

          const formData = getFormData(this)
          formData.append('token', token)

          axios
            .post('/index.php?route=tool/form&form_id=' + form.dataset.id, formData)
            .then(function (r) {
              const data = r.data
              if (data.success) {
                onSuccess(data.success)
              } else if (data.error.isPrototypeOf(Array)) {
                onValidationError(data.error)
              } else {
                onFatalError()
              }
            })
            .catch(() => {
              onFatalError()
            })
        })
    })
  })
}

const FORM_SELECTOR = '.js-ajax-form'

export function initForms() {
  Array.from(document.querySelectorAll(FORM_SELECTOR)).forEach(function (form) {
    formHandler({
      form,
      onFatalError() {
      },
      onValidationError() {
      },
      onSuccess(html) {
        form.innerHTML = html
        analytics.ajaxFormSent()
      }
    })
  })
}
